import { render, staticRenderFns } from "./myPrize.vue?vue&type=template&id=774c1de7&scoped=true&"
import script from "./myPrize.vue?vue&type=script&lang=ts&"
export * from "./myPrize.vue?vue&type=script&lang=ts&"
import style0 from "./myPrize.vue?vue&type=style&index=0&id=774c1de7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774c1de7",
  null
  
)

export default component.exports